import script from "./resource.category.vue?vue&type=script&setup=true&lang=js"
export * from "./resource.category.vue?vue&type=script&setup=true&lang=js"

import "./resource.category.vue?vue&type=style&index=0&id=73e89c4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e89c4e"]])

export default __exports__